// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDQbjNhRn5rsmplCP7yYpasQgg8xQsJe-E",
  authDomain: "store-front-f30ea.firebaseapp.com",
  projectId: "store-front-f30ea",
  storageBucket: "store-front-f30ea.firebasestorage.app",
  messagingSenderId: "68961545655",
  appId: "1:68961545655:web:68d99ed260fff0474b0c32",
  measurementId: "G-0PL6JY1E7M"
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);

export { firebaseApp, auth };